<template>
  <div>
    <el-dialog
      width="90%"
      :title="editDialogTitle"
      :visible.sync="dialogEditVisible"
      :before-close="handleClose"
    >
      <el-form :inline="true" :model="editItemTitle" class="demo-form-inline">
        <el-form-item label="类型">
          <el-select
            size="small"
            @change="handleItemTypeChage"
            v-model="editItemTitle.ItemType"
            placeholder="请选择设置类型"
          >
            <el-option
              v-for="item in itemTypeOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称">
          <el-select
            size="small"
            filterable
            v-model="editItemTitle.KeyName"
            @change="selectNameGet"
            placeholder="请选择名称"
          >
            <el-option
              v-for="item in keyNameOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周期类型">
          <!-- -->
          <el-select
            size="small"
            @change="handlePeriodTypeChange"
            v-model="editItemTitle.PeriodType"
            placeholder="请选择周期类型"
          >
            <el-option
              v-for="item in periodTypeOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="周期">
          <span
            >{{ editItemTitle.Period
            }}{{ editItemTitle.PeriodType == 1 ? "季度" : "月" }}</span
          >
        </el-form-item>
      </el-form>
      <el-form :inline="true">
        <el-form-item>
          <el-button
            plain
            circle
            @click="Add"
            size="small"
            type="primary"
            icon="el-icon-plus"
          ></el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            plain
            circle
            @click="Del"
            size="small"
            type="danger"
            icon="el-icon-minus"
          ></el-button>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <el-table
        border
        :data="KPIList"
        show-summary
        @selection-change="handleSelection"
        style="width: 100%"
        size="small"
        sum-text="权重"
        :summary-method="GetSumRowValue"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column min-width="100" label="KPI类型">
          <template slot-scope="scope">
            <el-select
              size="small"
              v-model="scope.row.KPIType"
              placeholder="请选择KPI类型"
            >
              <el-option
                v-for="item in KPIItemOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="KPI" min-width="100" label="KPI名称">
          <template slot-scope="scope">
            <el-select
              v-if="scope.row.KPIType == 8"
              v-model="scope.row.KPI"
              placeholder="请选择KPI名称"
              @change="SetKPITemplate(scope.row)"
              size="small"
              filterable
            >
              <el-option
                v-for="item in KPIName8Option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-if="scope.row.KPIType == 1"
              v-model="scope.row.KPI"
              placeholder="请选择KPI名称"
              @change="SetKPITemplate(scope.row)"
              size="small"
              filterable
            >
              <el-option
                v-for="item in KPIName1Option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-if="scope.row.KPIType == 5"
              v-model="scope.row.KPI"
              placeholder="请选择KPI名称"
              @change="SetKPITemplate(scope.row)"
              size="small"
              filterable
            >
              <el-option
                v-for="item in KPIName5Option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-if="scope.row.KPIType == 6"
              v-model="scope.row.KPI"
              placeholder="请选择KPI名称"
              @change="SetKPITemplate(scope.row)"
              size="small"
              filterable
            >
              <el-option
                v-for="item in KPIName6Option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input
              v-if="
                scope.row.KPIType == 4 ||
                scope.row.KPIType == 7 ||
                scope.row.KPIType == 0 ||
                scope.row.KPIType == 3 ||
                scope.row.KPIType == 2
              "
              v-model="scope.row.KPI"
              placeholder="请填写KPI名称"
              size="small"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="KPIWeight" min-width="50" label="KPI权重">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.KPIWeight"
              size="small"
              placeholder="请填写权重"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column min-width="200" prop="Explain" label="指标说明">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Explain"
              size="small"
              placeholder="请填写指标说明"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column min-width="250" prop="Contents" label="考核细则">
          <template slot-scope="scope">
            <el-input
              type="textarea"
              v-model="scope.row.Contents"
              size="small"
              placeholder="请填写考核细则"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="isDisabled" @click="addKPIInfo()" type="primary"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetKPINameOptions,
  GetQuarter,
  GetMonth,
  GetTempateByKPITypeAndKPIName,
  SaveKPIItems,
  DeleteKPIItem,
  GetChargeDeptsByUserCode,
  GetFrameListByPid,
  GetUsers,
} from "../../until/ZeusApiSDK/Logic/KPILogic";
import {
  GetGuid,
  GetCurrentUserInfo,
} from "../../until/ZeusApiSDK/Logic/HomeLogic";
import {
  GetFrameByParentId,
  GetUserByParentId,
  GetDutysByFrameId,
} from "../../until/ZeusApiSDK/Logic/StructureLogic";
import { Decrypt, Encrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
export default {
  props: {
    _singleData: {
      type: Object,
    },
    _list: {
      type: Array,
    },
    _dialogVisible: {
      type: Boolean,
    },
    // watch:{
    _currentDeptId: {
      type: String,
    },
    _itemType: {
      type: Number,
    },
    //   deep:true
    // },
    _isAdd: {
      type: Boolean,
    },
    _dialogEditVisible: {
      type: Boolean,
    },
    _editDialogTitle: {
      type: String,
    },
  },
  data() {
    return {
      KPIList: this._list,
      viewDialogVisible: this._dialogVisible,
      dialogEditVisible: this._dialogEditVisble,
      editDialogTitle: this._editDialogTitle,
      itemTypeOption: [],
      editItemTitle: {
        // ItemType: 2,
        // KeyName: "",
        // PeriodType: 0,
        // Period: new Date().getMonth() + 1
      },
      periodTypeOption: [],
      KPIItemOption: [],
      KPIName1Option: [],
      KPIName5Option: [],
      KPIName6Option: [],
      KPIName8Option: [],
      keyNameOption: [],
      frameId: this._currentDeptId,
      selection: [],
      isAdd: this._isAdd,
      delKPIList: [],
      itemName: "",
      itemId: "",
      userinfo: {},
      currentRole: {}, //当前登录角色
      itemType: this._itemType, //当前木类型
      isUser: 0,
      currentUser: {},
      isDisabled: false, //按钮是否禁用
    };
  },

  created() {
    //获取当前用户角色
    this.getCurrentRole();
    this.userinfo = GetCurrentUserInfo();
    console.log(this._data, "=====>");
    this.InitOptions();
    if (!this.isAdd) {
      this.editItemTitle = this.KPIList[0];
    } else {
      this.itemType = 2;
      this.editItemTitle = {
        ItemType: 2,
        KeyName: "",
        PeriodType: 0,
        Period: new Date().getMonth() + 1,
      };
      var deptModelStory = window.sessionStorage.getItem("deptModel");
      var deptModel = JSON.parse(Decrypt(deptModelStory));
      if (deptModelStory) {
        this.frameId = deptModel.value;
      } else {
        if (!deptModel || deptModel.value == "无") {
          this.keyNameOption = {
            value: this.userinfo.TrueName,
            label: this.userinfo.UserCode,
          };
        } else {
          this.frameId = this.currentChargeDept.value;
        }
      }
      // this.editItemTitle.KeyName=this.userinfo.TrueName;
    }
    this.handleItemTypeChage(this.itemType);
    //获取数据
    // this.loadDialogData();
  },
  updated() {
    if (this.keyNameOption.length == 0) {
      this.keyNameOption.push({
        value: this._singleData.UserCode,
        label: this._singleData.TrueName
      });
    }
  },
  methods: {
    //获取当前用户角色
    getCurrentRole: function () {
      var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
      this.currentRole = JSON.parse(Decrypt(currentUserRole));
    },
    //页面打开将数据传过来(处理接口返回速度慢，父页面重新将值传一遍)
    loadDialogData: function () {
      //添加时默认为自己
      if (this.itemType == "undefined" || this.itemType == null) {
        this.itemType = this.editItemTitle.ItemType;
      }
      // this.itemType=itemType;
      // this.frameId=this._currentDeptId;
      //赋值之后重新加载信息
      this.handleItemTypeChage(this.itemType);
    },
    //初始化选项
    InitOptions: function () {
      this.itemTypeOption.push({ value: 0, label: "部门" });
      this.itemTypeOption.push({ value: 1, label: "岗位" });
      this.itemTypeOption.push({ value: 2, label: "个人" });
      //
      this.periodTypeOption.push({ value: 0, label: "月度" });
      this.periodTypeOption.push({ value: 1, label: "季度" });
      //
      this.KPIItemOption.push({ value: 1, label: "业绩指标" });
      this.KPIItemOption.push({ value: 0, label: "职能指标", disabled: true });
      this.KPIItemOption.push({ value: 2, label: "自定义", disabled: true });
      this.KPIItemOption.push({ value: 3, label: "其他", disabled: true });
      this.KPIItemOption.push({ value: 4, label: "内部管理指标" });
      this.KPIItemOption.push({ value: 5, label: "客户指标" });
      this.KPIItemOption.push({ value: 6, label: "敬业度" });
      this.KPIItemOption.push({ value: 7, label: "重点项目" });
      this.KPIItemOption.push({ value: 8, label: "团队管理" });
      this.SetKPINameOptionsByNum(1, this.KPIName1Option);
      this.SetKPINameOptionsByNum(5, this.KPIName5Option);
      this.SetKPINameOptionsByNum(6, this.KPIName6Option);
      this.SetKPINameOptionsByNum(8, this.KPIName8Option);
    },
    //增加一条
    Add: function () {
      if (
        this.keyNameOption.filter(
          (p) =>
            p.value == this.editItemTitle.KeyName ||
            p.value == this.editItemTitle.KeyId
        ).length > 0
      ) {
        var userinfo = this.userinfo;
        var kpi = {
          Id: "",
          KPI: "",
          ItemType: this.itemType,
          KeyId: this.editItemTitle.KeyName,
          KeyName: this.keyNameOption.filter(
            (p) =>
              p.value == this.editItemTitle.KeyName ||
              p.value == this.editItemTitle.KeyId
          )[0].label,
          TargetType: "",
          Sort: this.KPIList.length + 1,
          KPIWeight: 0,
          PeriodType: this.editItemTitle.PeriodType,
          Period: this.editItemTitle.Period,
          KPIType: 1,
          Explain: "",
          Contents: "",
          IsDel: 0,
          UserCode: userinfo.UserCode,
          TrueName: userinfo.TrueName,
          MainDeptsID: userinfo.FrameId,
          MainDeptsName: userinfo.FrameName,
          DeptsId: this.frameId,
          KPIInfoId: "1",
          CreateTime: new Date(),
          Remark: this.frameId,
          Status: 0,
        };
        this.KPIList.push(kpi);
        // GetGuid().then(res => {
        //   var kpi = {
        //     Id: res,
        //     KPI: "",
        //     ItemType: this.itemType,
        //     KeyId: this.editItemTitle.KeyName,
        //     KeyName: this.keyNameOption.filter(
        //       p => p.value == this.editItemTitle.KeyName||p.value == this.editItemTitle.KeyId
        //     )[0].label,
        //     TargetType: "",
        //     Sort: this.KPIList.length + 1,
        //     KPIWeight: 0,
        //     PeriodType: this.editItemTitle.PeriodType,
        //     Period: this.editItemTitle.Period,
        //     KPIType: 0,
        //     Explain: "",
        //     Contents: "",
        //     IsDel: 0,
        //     UserCode: userinfo.UserCode,
        //     TrueName: userinfo.TrueName,
        //     MainDeptsID: userinfo.FrameId,
        //     MainDeptsName: userinfo.FrameName,
        //     DeptsId: this.frameId,
        //     KPIInfoId: "1",
        //     CreateTime: new Date(),
        //     Remark: this.frameId,
        //     Status: 0
        //   };
        //   this.KPIList.push(kpi);
        // });
      } else {
        if (this.editItemTitle.KeyName == "") {
          this.$message({
            message: "未选择名称",
            type: "warning",
            center: true,
          });
        } else {
          this.$message({
            message: "当前名称不在当前操作部门中",
            type: "warning",
            center: true,
          });
        }
      }
    },
    //删除几条
    Del: function () {
      if (this.selection.length == 0) {
        this.$message({
          message: "请至少选择一项",
          type: "warning",
          center: true,
        });
      } else {
        this.$confirm("此操作删除KPI条目, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.selection.forEach((element) => {
              if (!this.isAdd) {
                element.IsDel = 1;
                this.delKPIList.push(element); //编辑状态下，删除的条目存入删除数组中
              }
              this.KPIList.splice(this.KPIList.indexOf(element), 1);
            });
            var ids = "";
            this.delKPIList.forEach((v) => {
              ids += v.Id + ",";
            });
            ids = ids.substring(0, ids.length - 1);
            //删除不添加任何操作
            DeleteKPIItem(this.userinfo.UserCode, ids).then((res) => {
              // if(res.Result==1){
              //   this.$router.go(0);
              // }
            });
          })
          .catch((e) => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    //根据选择项id获取value值
    selectNameGet: function (vid) {
      let obj = {};
      obj = this.keyNameOption.find((item) => {
        //这里的userList就是上面遍历的数据源
        if (item.value === vid) {
          this.itemId = item.value;
          this.itemName = item.label;
        }
      });
    },
    //添加KPI考核项
    addKPIInfo: function () {
      this.isDisabled = true;
      var userinfo = this.userinfo;
      //userinfo.UserCode
      var paras = {};
      //将KPI考核项循环获取并添加到固定值中
      var kpiItems = [];
      if (this._isAdd) {
        //添加时
        paras = {
          //类型：0部门，1岗位，2个人
          itemType: this.itemType,
          //根据类型，判断是部门id，岗位id或者人员id
          KeyId: this.editItemTitle.KeyName,
          //根据类型，判断是部门名称，岗位名称或者人员名称
          KeyName: this.itemName,
          //周期类型：0月度，1季度
          PeriodType: this.editItemTitle.PeriodType,
          //周期
          Period: this.editItemTitle.Period,
          //创建人工号
          userCode: userinfo.UserCode,
          //当前操作部门
          frameId: this.frameId == "无" ? userinfo.FrameId : this.frameId,
        };
        this.KPIList.forEach(function (v) {
          var model = {
            id: "",
            KPIWeight: v.KPIWeight,
            KPIType: v.KPIType,
            Explain: v.Explain,
            Contents: encodeURIComponent(v.Contents),
            TargetType: v.TargetType,
            KPI: v.KPI,
          };
          kpiItems.push(model);
        });
      } else {
        //编辑时
        paras = {
          //类型：0部门，1岗位，2个人
          itemType: this.itemType,
          //根据类型，判断是部门id，岗位id或者人员id
          KeyId: this.editItemTitle.KeyId,
          //根据类型，判断是部门名称，岗位名称或者人员名称
          KeyName: this.keyNameOption.filter(
            (p) =>
              p.label == this.editItemTitle.KeyName ||
              p.label == this.editItemTitle.KeyId
          )[0].label, //this.editItemTitle.KeyName,
          //周期类型：0月度，1季度
          PeriodType: this.editItemTitle.PeriodType,
          //周期
          Period: this.editItemTitle.Period,
          //创建人工号
          userCode: userinfo.UserCode,
          //当前操作部门
          // frameId:
          //   this.editItemTitle.MainDeptsID == "无"
          //     ? userinfo.FrameId
          //     : this.editItemTitle.MainDeptsID,
          frameId: this.frameId == "无" ? userinfo.FrameId : this.frameId,
        };
        this.KPIList.forEach(function (v) {
          v.Contents = encodeURIComponent(v.Contents);
          kpiItems.push(v);
        });
      }
      //添加KPI
      SaveKPIItems(paras, kpiItems).then((res) => {
        if (res.Result == 1) {
          if (this._isAdd) {
            //添加时刷新页面
            this.$router.go(0);
          } else {
            //编辑时 关掉本窗口打开父窗口
            this.$emit("update:_dialogEditVisible", false);
            this.$emit("update:_list", this.KPIList);
          }
        } else {
          // this.isDisabled=false;
          this.$message(res.Message);
        }
      });
    },
    handleSelection(val) {
      this.selection = val;
    },
    SetKPITemplate: function (row) {
      GetTempateByKPITypeAndKPIName(
        row.KPIType,
        row.KPI,
        this.editItemTitle.PeriodType
      ).then((res) => {
        if (res.status == 200) {
          row.KPIWeight = res.model.KPIWeight;
          row.Explain = res.model.Explain;
          row.Contents = res.model.Contents;
        }
      });
    },
    SetKPINameOptionsByNum: function (num, arr) {
      GetKPINameOptions(num).then((res) => {
        if (res.list) {
          res.list.forEach((element) => {
            arr.push({
              value: element.ClassName,
              label: element.ClassName,
            });
          });
        }
      });
    },
    handleItemTypeChage(val) {
      this.itemType = val;
      this.keyNameOption = [];
      // this.editItemTitle.KeyName = "";
      if (val == 0) {
        //部门
        this.GetItemNameOptionDepts();
      } else if (val == 1) {
        //岗位
        this.GetItemNameOptionDuties();
      } else if (val == 2) {
        //个人
        this.GetItemNameOptionUsers();
      }
    },
    handlePeriodTypeChange(val) {
      if (val == 0) {
        this.editItemTitle.Period = GetMonth();
      } else if (val == 1) {
        this.editItemTitle.Period = "Q" + GetQuarter();
      }
    },
    handleClose: function () {
      this.dialogEditVisible = false;
      this.$emit("update:_dialogEditVisible", false);
    },
    //根据类型选择获取部门
    GetItemNameOptionDepts: function (val) {
      GetFrameListByPid(this.frameId).then((res) => {
        if (res.list.length > 0) {
          this.keyNameOption = [];
          res.list.forEach((element) => {
            this.keyNameOption.push({
              value: element.Id,
              label: element.ClassName,
            });
          });
          var keyItem = this.keyNameOption.filter(
            (x) => x.value == this.editItemTitle.KeyId
          );
          this.editItemTitle.KeyName =
            keyItem.length > 0 ? keyItem[0].label : "";
        }
      });
    },
    //根据部门id获取人员
    GetItemNameOptionUsers: function () {
      // this.frameId=this._currentDeptId;
      this.isUser = 0;
      if (this.currentRole.Key == "user") {
        this.isUser = 1;
      }
      GetUsers(this.frameId, this.userinfo.UserCode, this.isUser).then(
        (res) => {
          if (res) {
            if (res.list.length > 0) {
              this.keyNameOption = [];

              res.list.forEach((element) => {
                this.keyNameOption.push({
                  value: element.Id,
                  label: element.TrueName,
                });
              });

              var keyItem = this.keyNameOption.filter(
                (x) => x.value == this.editItemTitle.KeyId
              );
              this.editItemTitle.KeyName =
                keyItem.length > 0 ? keyItem[0].label : "";
            }
          }
        }
      );
    },
    GetItemNameOptionDuties: function (val) {
      GetDutysByFrameId(this.frameId).then((res) => {
        if (res.list.length > 0) {
          this.keyNameOption = [];
          res.list.forEach((element) => {
            this.keyNameOption.push({
              value: element.Id,
              label: element.Duty,
            });
          });
          var keyItem = this.keyNameOption.filter(
            (x) => x.value == this.editItemTitle.KeyId
          );
          this.editItemTitle.KeyName =
            keyItem.length > 0 ? keyItem[0].label : "";
        }
      });
    },
    setEditItemTitle: function () {
      if (!this.isAdd && this.KPIList.length > 0) {
        this.editItemTitle = this.KPIList[0];
      }
    },
    GetSumRowValue(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 3) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = "N/A";
          }
        } else if (index === 0) {
          sums[index] = "合计";
        }
      });
      return sums;
    },
  },
  watch: {
    _list: {
      handler(n, o) {
        //n为新值,o为旧值;
        this.KPIList = n;
        this.setEditItemTitle();
        // this.loadDialogData();
      },
      deep: true,
    },
    _isAdd: {
      handler(n, o) {
        //n为新值,o为旧值;
        this.isAdd = n;
        if (this.isAdd) {
          this.editItemTitle = {
            ItemType: 2,
            KeyName: "",
            PeriodType: 0,
            Period: new Date().getMonth() + 1,
          };
          this.itemType = this.editItemTitle.ItemType;
        }
        this.setEditItemTitle();
        this.loadDialogData();
      },
      deep: true,
    },
    _itemType: {
      handler(n, o) {
        //n为新值,o为旧值;
        this.itemType = n;
        // this.setEditItemTitle();
        this.loadDialogData();
      },
      deep: true,
    },
    _dialogEditVisible: {
      handler(n, o) {
        //n为新值,o为旧值;
        this.dialogEditVisible = n;
      },
      deep: true,
    },
    //部门变化时
    _currentDeptId: {
      handler(n, o) {
        //n为新值,o为旧值;
        this.frameId = n;
        this.loadDialogData();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less" scoped>
.el-form {
  text-align: left;
}
.el-form-item {
  margin-top: 2px;
  margin-bottom: 2px;
}
/deep/.el-divider {
  margin-top: 2px;
  margin-bottom: 2px;
}
</style>